import { Select, Option, Popover } from 'element-ui';
import { EventBus } from '@/services/Event.js';
import Vue from 'vue';

export default {
    name: 'SelectListAnswer',
    inject: {
        highlight_invalid_fields: { default: false }
    },
    props: {
        id: [Number, String],
        value: [String, Number],
        values_array: Array,
        options: { type: Array, default: [] },
        api: String,
        valid: Boolean,

        visibility_dependent_fields: { type: Array, default: [] },
        is_mandatory: Boolean,
        is_mandatory_if_visible: Boolean,
        label: String,
        label_class: { type: String, default: '' },
        disabled: { type: Boolean, default: false },
        visible: { type: Boolean, default: true },
        hint: String,
        hint_type: { type: String, default: 'warning' },
        preview: { type: Boolean, default: false },
        placeholder: { type: String, default: 'value' },
        is_multiple: Boolean,
        error_messages: Array,
        is_default_if_not_in_list: { type: Boolean, default: false },
        default_value: [Number, String],
        smallest: { type: String, default: 'col-12' }, small: { type: String, default: 'col-sm-12' }, medium: { type: String, default: 'col-md-12' }, large: { type: String, default: 'col-lg-12' }, largest: { type: String, default: 'col-lg-12' },
    },
    components: {
        [Select.name]: Select,
        [Option.name]: Option,
        [Popover.name]: Popover,
    },
    computed: {
        is_removed_item_read_only() {
            if (this.remove_item) {
                var itemArray = this.options.filter(x => { return x.value === this.remove_item });
                if (itemArray && itemArray.length) {
                    var item = itemArray[0];

                    if (item && item.isReadOnly) {
                        return true;
                    }
                }
            }
            return false;
        },
        column_class_default() {
            return `${this.largest} ${this.large} ${this.medium} ${this.small} ${this.smallest}`
        },
        label_class_value() {
            return `float-left ${this.label_class}`
        },
        value_label() {
            var itemArray = this.options.filter(x => { return x.value === this.value });
            if (itemArray && itemArray.length) {
                var item = itemArray[0];

                if (item && item.label) {
                    return item.label;
                }
            }

            return "";
        },
        show_error_highlight() {
            var hasValue = this.is_multiple
                ? !!(this.prop_value && this.prop_value.length)
                : this.prop_value !== null && this.prop_value !== undefined && this.prop_value !== '';

            return this.highlight_invalid_fields
                && this.valid === false
                && (this.touched || hasValue);
        }
    },
    watch: {
        options: { // watch it
            immediate: true,
            handler(val, oldVal) {
                if (this.options && this.options.length) {
                    this.set_prop_value();

                    if (this.prop_value || this.is_mandatory || this.is_mandatory_if_visible) {
                        this.handler_change();
                    }
                }
                else {
                    this.load_from_api();
                }
            }
        },
        value: {
            immediate: true,
            handler(val, oldVal) {
                //if (this.label == "Swim Distance") {
                //    debugger
                //}
                this.set_prop_value();

                if (val != oldVal) {
                    if ((this.prop_value || this.is_mandatory || this.is_mandatory_if_visible) && !this.api) {
                        this.handler_change();
                    }
                }
            }
        }
    },
    data() {
        return {
            is_processing: false,
            prop_value: "",
            remove_item: null,
            touched: false
        };
    },
    methods: {
        on_user_change() {
            this.touched = true;
            this.handler_change();
        },
        get_label(value) {
            var itemArray = this.options.filter(x => { return x.value === value });
            if (itemArray && itemArray.length) {
                var item = itemArray[0];

                if (item && item.label) {
                    return item.label;
                }
            }
        },
        findWithAttr(array, attr, value) {
            for (var i = 0; i < array.length; i += 1) {
                if (array[i][attr] === value) {
                    return i;
                }
            }
            return -1;
        },
        get_id_current_value(checkValue) {

            var value = this.prop_value;
            if (checkValue) {
                value = checkValue;
            }

            var data = this.options.filter(x => x.value == value);
            return data && data.length ? data[0].id : -1;
        },
        validate() {
            let new_warnings = [];
            if (this.is_mandatory || this.is_mandatory_if_visible) {
                if (this.is_multiple) {
                    if (!this.prop_value || !this.prop_value.length) {
                        new_warnings.push("Please select at lease one value. This field cannot be empty");
                    }
                }
                else {
                    if (!this.prop_value) {
                        new_warnings.push("Please select some value. This field cannot be empty");
                    }
                }

            }
            let prop_valid = !new_warnings.length;
            this.$emit("update:valid", prop_valid);
            this.$emit("update:error_messages", new_warnings);

        },
        handler_change() {
            var self = this;
            if (self.is_processing) {
                return;
            }

            //if (this.label == "Swim Distance") {
            //    debugger
            //}

            self.validate();
            if (self.is_multiple) {
                self.$emit("update:values_array", self.prop_value);
            } else {
                self.$emit("update:value", self.prop_value);
            }

            if (self.visibility_dependent_fields && self.visibility_dependent_fields.length) {
                if (self.is_multiple) {
                    setTimeout(() => self.visibility_dependent_fields.forEach(enumValue => {
                        var values = [];
                        if (self.prop_value && self.prop_value.length) {
                            self.prop_value.forEach(x => {
                                values.push(self.get_id_current_value(x));
                            });
                        }

                        EventBus.$emit(`update-visibility-multiple-field-id-${enumValue}`, values)
                    }), 0);
                }
                else {
                    var id_current_value = self.get_id_current_value(self.prop_value);
                    if (id_current_value > -1) {
                        setTimeout(() => self.visibility_dependent_fields.forEach(enumValue => {
                            EventBus.$emit(`update-visibility-field-id-${enumValue}`, id_current_value)
                        }), 0);
                    }
                }
            }
        },
        set_prop_value() {
            if (this.is_multiple) {
                if (this.values_array && this.values_array.length && this.values_array[0]) {
                    this.prop_value = this.values_array;
                } else {
                    this.prop_value = [];
                }
            }
            else
                if (this.options && this.options.length) {
                    if (this.options.filter(x => { return x.value === this.value }).length) {
                        this.prop_value = this.value;
                    }
                    else
                        if (this.options.filter(x => { return x.value === `${this.value}` }).length) {
                            this.prop_value = `${this.value}`;
                        }
                        else {
                            if (this.is_default_if_not_in_list && this.default_value && this.value && !this.api) {
                                this.$emit("update:value", `${this.default_value}`);
                            } else {
                                this.prop_value = null;
                                this.handler_change();
                            }
                        }
                }
                else {
                    this.prop_value = null;
                    this.handler_change();
                }
        },
        load_from_api() {
            if (this.api && !this.is_processing) {
                var self = this;
                self.is_processing = true;
                Vue.http.get(self.api)
                    .then(response => {
                        if (response && response.body && response.body.isSuccess) {
                            self.$emit("update:options", response.body.outputData)
                        }

                        self.is_processing = false;
                    }, () => self.is_processing = false);
            }
        },
        remove_tab_index() {
            if (this.$refs && Object.keys(this.$refs).length) {
                Object.keys(this.$refs).forEach(prop => {
                    if (this.$refs[prop] && this.$refs[prop].$el && this.$refs[prop].$el.children && this.$refs[prop].$el.children.length) {
                        this.$refs[prop].$el.children[1].tabIndex = -1;
                    }
                })
            }
        },
        remove_tag(item) {
            this.remove_item = item;
            if (this.is_removed_item_read_only) {
                this.prop_value.push(this.remove_item);
                this.handler_change();
                this.remove_item = null;
                this.$notify({
                    message: "This option cannot be deleted.",
                    type: 'danger',
                    timeout: 3000
                });
            }
        }
    },
    mounted() {
        if (this.options && this.options.length) {
            this.is_processing = false;
        }
        else {
            this.load_from_api();
        }
        this.remove_tab_index();

        var self = this;
        EventBus.$off(`handler-change-answer-id-${this.id}`);
        EventBus.$on(`handler-change-answer-id-${this.id}`, () => { self.handler_change(); });

        if (this.is_mandatory || this.is_mandatory_if_visible) {
            this.validate();
        }
    }
};



// WEBPACK FOOTER //
// ./src/components/shared/answer-types/select-list/select-list.js